<template>
<div id="root">
	<template v-if="initialized">
		<template v-if="!identity.id">
			<LoginPage />
		</template>
		<template v-else>
			<Navbar :pages="pages" @switch-tab="currentPage = $event" />
			<Notifications />
			<RegisterPage v-if="currentPage === 'register'" />
			<GreetingPage v-if="currentPage === 'greeting'" />
			<ChangeBranchPage v-if="currentPage === 'info'" />
		</template>
	</template>
	<div v-else :class="style.loadingWrapper">
		<Card :class="style.loadingBox">
			<div :class="style.loadingContent">
				<img :class="style.loading" src="@/images/loading.gif" alt="loading" />
			</div>
		</Card>
	</div>
</div>
</template>

<script lang="ts">
import { computed, defineComponent, inject, onMounted, provide, ref, useCssModule } from 'vue'
import { useIdentity } from '@/composables/useIdentity'
import Navbar from '@/components/Navbar.vue'
import Card from '@/components/Card.vue'
import Notifications from '@/components/Notifications.vue'
import LoginPage from '@/pages/LoginPage.vue'
import GreetingPage from '@/pages/GreetingPage.vue'
import RegisterPage from '@/pages/RegisterPage.vue'
import ChangeBranchPage from '@/pages/ChangeBranchPage.vue'

const pages = [
	{ id: 'info', name: '我的資料' },
	{ id: 'order', name: '我的訂單' },
]

export default defineComponent({
	components: {
		Navbar,
		Card,
		LoginPage,
		Notifications,
		GreetingPage,
		RegisterPage,
		ChangeBranchPage,
	},
	setup() {
		const initialized = inject('appInitialized', false)
		const identity = useIdentity()
		const currentPage = ref('greeting')

		provide('globalStyle', useCssModule('global'))
		onMounted(() => $(document).trigger('vueApp:mounted'))

		return {
			style: useCssModule(),
			initialized,
			identity,
			pages,
			currentPage: computed({
				get: () => (
					identity.isRegistered ? currentPage.value : 'register'
				),
				set(v) {
					currentPage.value = v
				},
			}),
		}
	},
})
</script>

<style lang="scss" module>
.loading-wrapper {
	height: 100vh;
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
}

.loading-box {
	min-width: 280px;
	max-width: 90vw;
	width: 500px;
}

.loading-content {
	display: flex;
	flex-flow: column;
	align-items: center;
}

.loading {
	height: 64px;
}
</style>

<style lang="scss" module="global">
.inputbox {
	border: 1px solid gray;
	border-radius: 5px;
	padding: 10px;
	font-size: 18px;
	min-width: 6em;

	&[disabled] {
		border: none;
		padding: 11px 0;
	}
}

.button {
	cursor: pointer;
	text-align: center;
	border-radius: 8px;
	background-color: slategrey;
	color: snow;
	width: auto;
	text-decoration: none;
	padding: 12px;
	margin: 1em 0 0;
}
</style>
